import { get, post } from "@insite/client-framework/Services/ApiService";
import { GetPaymetricResponsePacketApiParameter, PaymetricResponseApiResult } from "@insite/client-framework/Services/CartService";
import { PaymetricConfig } from "@insite/client-framework/Services/SettingsService";

export function getPaymetricConfig() {
    return post<PaymetricConfig>("/api/custom/paymetric/config");
}

export function getInvoicePaymentPaymetricConfig() {
    return post<PaymetricConfig>("/api/custom/invoicePayment/paymetric");
}

export function getInvoicePaymentPaymetricResponsePacketApi(parameter: GetPaymetricResponsePacketApiParameter) {
    return get<PaymetricResponseApiResult>("/api/custom/invoicePayment/packet", parameter);
}
